/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PhoneStatus } from '@medflex/shared-types';
import { useTranslation } from 'react-i18next';
import { CheckCircleIcon, MinusCircleIcon, XCircleIcon } from '@heroicons/react/24/solid';

const PHONE_STATUS_TO_ICON = {
  [PhoneStatus.COMPLETED]: {
    IconComponent: CheckCircleIcon,
    iconClassName: 'text-green-500',
  },
  [PhoneStatus.UNCOMPLETED]: {
    IconComponent: MinusCircleIcon,
    iconClassName: 'text-orange-500',
  },
  [PhoneStatus.CANCELED]: {
    IconComponent: XCircleIcon,
    iconClassName: 'text-red-500',
  },
};

const PHONE_STATUS_TO_COLOR_CONFIG = {
  [PhoneStatus.COMPLETED]: 'bg-green-200 text-green-800',
  [PhoneStatus.UNCOMPLETED]: 'bg-orange-200 text-orange-800',
  [PhoneStatus.CANCELED]: 'bg-red-200 text-red-800',
};

export const Variants = {
  ICON: 'icon',
  FULL: 'full',
};

const PhoneStatusBadge = ({ phoneStatus, variant = Variants.FULL }) => {
  const { t } = useTranslation('components', { keyPrefix: 'PamInquiry' });
  const badgeColorConfig = PHONE_STATUS_TO_COLOR_CONFIG[phoneStatus];
  const { IconComponent, iconClassName } = PHONE_STATUS_TO_ICON[phoneStatus];
  const cn = classNames([
    'flex',
    'items-center',
    'rounded-full',
    'px-2.5',
    'py-1',
    'text-sm',
    'font-semibold',
    'max-w-xs',
    'space-x-0.5',
    badgeColorConfig,
  ]);

  if (Variants.ICON === variant) {
    return (
      <span className={`${badgeColorConfig} bg-transparent`}>
        <IconComponent className={`${iconClassName} w-6 h-6`} />
      </span>
    );
  }

  return (
    <div className={cn}>
      <IconComponent className={`${iconClassName} w-5 h-5 -ml-1.5`} />
      <span className="truncate">{t(`phoneStatus.${phoneStatus}`)}</span>
    </div>
  );
};

PhoneStatusBadge.propTypes = {
  phoneStatus: PropTypes.oneOf(Object.values(PhoneStatus)).isRequired,
  variant: PropTypes.oneOf(Object.values(Variants)),
};

export default PhoneStatusBadge;
